module.exports = __webpack_public_path__ + "nitf_icon.png";


//////////////////
// WEBPACK FOOTER
// ./app/nitf_icon.png
// module id = 1
// module chunks = 0